import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=61717d1b&scoped=true&"
import script from "./EventsCalendar.vue?vue&type=script&lang=js&"
export * from "./EventsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61717d1b",
  null
  
)

export default component.exports